//Reactアプリの状態（user）を管理
import React, { createContext, useContext, useEffect, useState, useRef } from 'react';
import * as authApi from '../api/auth';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const inFlightGetUser = useRef(null);

  // 初期読み込み（ログイン状態確認）
  useEffect(() => {
    // Prevent duplicate concurrent getUser requests (e.g. React.StrictMode double-mount)
    let cancelled = false;
    const doFetch = async () => {
      try {
        if (!inFlightGetUser.current) {
          inFlightGetUser.current = authApi.getUser();
        }
        const data = await inFlightGetUser.current;
        if (cancelled) return;
        setUser(data);
      } catch (e) {
        setUser(null);
      } finally {
        inFlightGetUser.current = null;
        if (!cancelled) setLoading(false);
      }
    };

    doFetch();
    return () => {
      cancelled = true;
    };
  }, []);

  const refreshUser = async () => {
    try {
      // Reuse any in-flight request to avoid duplicate /user calls
      if (!inFlightGetUser.current) {
        inFlightGetUser.current = authApi.getUser();
      }
      const data = await inFlightGetUser.current;
      setUser(data);
      inFlightGetUser.current = null;
      return data;
    } catch (e) {
      setUser(null);
      return null;
    }
  };

  const login = (userData) => {
    setUser(userData);
  };

  const logout = async () => {
    try {
      await authApi.logout();
    } catch (e) {
      console.warn('APIログアウト失敗（無視）');
    }
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, refreshUser, loading }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
